import { Component } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import * as Color from 'color';

@Component({
  selector: 'app-landing-bg',
  templateUrl: './landing-bg.component.html'
})
export class LandingBgComponent {
  public corporativeColor: Color;

  constructor(
    private config: ConfigService
  ) {
    this.corporativeColor = this.config.checkin.corporativeColor;
  }
}
